// extracted by mini-css-extract-plugin
export default {"cls1":"FreeformQuestion-cls1__cd9d6beb699cb82af503","cls2":"FreeformQuestion-cls2__ac7e720b59ec7bf30180 FreeformQuestion-cls1__cd9d6beb699cb82af503"};